import * as React from 'react';

import { useSelector } from 'react-redux';
import { selectGamesByProvider, selectGamesLoading } from '@/store/games/selectors';
import CategoryPageContent from '@/pages/games/categories/CategoryPageContent';
import EmptyGamesPlaceholder from '@/pages/games/EmptyGamesPlaceholder';
import { BffGamesCategory } from '@lucky7ventures/bff-types';
import GamesByProviderSkeletonLoader from '@/components/shared/skeleton-loader/GamesByProviderSkeletonLoader';
import ProviderGamesLayout from '@/pages/games/providers/ProviderGamesLayout';
import { useParams } from 'react-router-dom';

function GamesByProvider(): JSX.Element | null {
  const { provider } = useParams<{ provider?: string }>();
  const selectedProvider = useSelector(selectGamesByProvider(provider || ''));
  const gamesLoading = useSelector(selectGamesLoading);

  if (!provider) {
    return null;
  }

  if (gamesLoading) {
    return (
      <ProviderGamesLayout provider={provider}>
        <GamesByProviderSkeletonLoader />
      </ProviderGamesLayout>
    );
  }

  if (!selectedProvider) {
    return (
      <ProviderGamesLayout provider={provider}>
        <EmptyGamesPlaceholder category={BffGamesCategory.AllGames} />
      </ProviderGamesLayout>
    );
  }

  return (
    <ProviderGamesLayout provider={provider}>
      <CategoryPageContent
        category={BffGamesCategory.AllGames}
        games={selectedProvider.games}
        loading={gamesLoading}
      />
    </ProviderGamesLayout>
  );
}

export default GamesByProvider;
